<form id="registerForm" [formGroup]="RegisterForm" (ngSubmit)="register()">
  <div class="auth">
    <label for="email" class="outside-window">Email</label>
    <input
      id="email"
      formControlName="email"
      type="email"
      class="auth-container"
      placeholder="Email"
      [ngClass]="{ 'is-invalid': isSubmitted && email.invalid }" />
  </div>
  <div class="error-msg">
    @if (isSubmitted && email.errors?.['required']) {
      <span class="error-text">Email requis</span>
    }
    @if (isSubmitted && email.errors?.['pattern']) {
      <span class="error-text">Format d'email invalide</span>
    }
    @if (isSubmitted && email.errors?.['emailTaken']) {
      <span class="error-text">Cet email est déjà utilisé</span>
    }
  </div>

  <div class="auth">
    <div>
      <label for="password" class="outside-window">Mot de passe</label>
      <div class="password-input-wrapper">
        <input
          id="password"
          formControlName="password"
          [type]="passwordVisible ? 'text' : 'password'"
          class="auth-container"
          placeholder="Mot de passe"
          [ngClass]="{ 'is-invalid': isSubmitted && password.invalid }" />
        <button
          type="button"
          class="toggle-password-visibility"
          (click)="togglePasswordVisibility('password')"
          aria-label="Afficher/Masquer le mot de passe">
          @if (passwordVisible) {
            <img ngSrc="assets/eye.svg" alt="Masquer le mot de passe" fill />
          } @else {
            <img ngSrc="assets/eye-slash.svg" alt="Afficher le mot de passe" fill />
          }
        </button>
      </div>
    </div>
  </div>
  <div class="error-msg">
    @if (isSubmitted && password.errors?.['required']) {
      <span class="error-text">Mot de passe requis</span>
    }
    @if (isSubmitted && (password.errors?.['pattern'] || password.errors?.['minlength'])) {
      <div class="error-box">
        <p class="error-title">Le mot de passe doit contenir 12 caractères minimum :</p>
        <ul class="error-list">
          <li>Au moins une majuscule</li>
          <li>Au moins une minuscule</li>
          <li>Au moins un chiffre</li>
          <li>Au moins un caractère spécial (&#64; $ ! % * ? &amp; #)</li>
        </ul>
      </div>
    }
  </div>

  <div class="auth">
    <div>
      <label for="confirmPassword" class="outside-window">Confirmer le mot de passe</label>
      <div class="password-input-wrapper">
        <input
          id="confirmPassword"
          formControlName="confirmPassword"
          [type]="confirmPasswordVisible ? 'text' : 'password'"
          class="auth-container"
          placeholder="Confirmation du mot de passe"
          [ngClass]="{ 'is-invalid': isSubmitted && confirmPassword.invalid }" />
        <button
          type="button"
          class="toggle-password-visibility"
          (click)="togglePasswordVisibility('confirmPassword')"
          aria-label="Afficher/Masquer la confirmation du mot de passe">
          @if (confirmPasswordVisible) {
            <img ngSrc="assets/eye.svg" alt="Masquer le mot de passe" fill />
          } @else {
            <img ngSrc="assets/eye-slash.svg" alt="Afficher le mot de passe" fill />
          }
        </button>
      </div>
    </div>
  </div>

  <div class="error-msg">
    @if (isSubmitted && confirmPassword.errors?.['required']) {
      <span class="error-text">Confirmation du mot de passe requise</span>
    }
    @if (isSubmitted && passwordMismatch) {
      <span class="error-text">Les mots de passe ne correspondent pas</span>
    }
  </div>

  <div class="rgpd-container">
    <label class="rgpd-checkbox">
      <input
        type="checkbox"
        id="rgpdConsent"
        formControlName="rgpdConsent"
        [ngClass]="{ 'is-invalid-checkbox': isSubmitted && rgpdConsent.invalid }" />
      <span>
        J'accepte la
        <a href="/privacy-policy" target="_blank">politique de confidentialité</a>
        et les
        <a href="/terms-of-service" target="_blank">conditions générales d'utilisation</a>
      </span>
    </label>
  </div>
  <div class="error-msg">
    @if (isSubmitted && rgpdConsent.invalid) {
      <span class="error-text">Vous devez accepter pour créer un compte</span>
    }
  </div>

  <div class="auth submit-section">
    <button type="submit" class="button-component" [disabled]="isLoading || rgpdConsent.invalid">
      {{ isLoading ? 'Chargement...' : "S'inscrire" }}
    </button>
  </div>

  <div class="git">
    <div class="separator-text">
      <span>OU</span>
    </div>
    <a href="javascript:void(0)" (click)="loginWithGitHub()" class="button-component centered-git-flex">
      <img src="assets/github.svg" alt="GitHub" class="github-icon" />
      Continuer avec GitHub
    </a>
  </div>
</form>
